import { createClient } from '@supabase/supabase-js'

// Snapshot verify params before createClient: supabase-js strips them from the URL on init.
export const initialUrlAuthParams =
  typeof window !== 'undefined'
    ? { search: window.location.search, hash: window.location.hash }
    : { search: '', hash: '' }

export const supabase = createClient(
  import.meta.env.SUPABASE_URL as string,
  import.meta.env.SUPABASE_PUBLISHABLE_KEY as string,
)
